export const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AWS_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_AWS_CLIENT_ID,
  metadataSeed: {
    token_endpoint: process.env.REACT_APP_OAUTH_TOKEN_URL,
  },
  disablePKCE: false,
  redirect_uri: window.location.href.includes("localhost")
    ? "http://localhost:3000"
    : process.env.REACT_APP_URL_LOCATION,
  response_type: "code",
  scope: "email openid phone profile",
  onSigninCallback: () => {
    const url = new URL(window.location.href);
    ["code", "state", "session_state"].forEach((parameter) => {
      url.searchParams.delete(parameter);
    });
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  },
};
